import { createSelector } from '@ngrx/store';
import { getManagementState, ManagementState } from '../management.reducer';
import { adapter, LanguageAssignmentsState } from './language-assignments.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getManagementState, (state: ManagementState) => state.languageAssignments);
const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getAllLocations = createSelector(getState, (state: LanguageAssignmentsState) => state.locations);

const getValidAll = createSelector(
    entitySelectors.selectAll,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (languageAssignments, hasError, success) => (!hasError && success ? languageAssignments : null)
);


const getIsEnglish = createSelector(getState, (state: LanguageAssignmentsState) => state.english);
const getIsSpanish = createSelector(getState, (state: LanguageAssignmentsState) => state.spanish);

export const LanguageAssignmentsSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getValidAll,
    getAllLocations,
    getIsEnglish,
    getIsSpanish
};
